import React, { Suspense } from 'react'
import { ThemeProvider } from 'styled-components'
import ThemeWrapper from 'components_v1/v2Wrappers/ThemeWrapper'
import { LightTheme } from 'ui/bend'

const BottomWidget = React.lazy(() =>
  import(/* webpackChunkName: 'video-player' */ './BottomWidget')
)

/*
This component is used as a shim to load the new Footer in old non-redesigned pages
*/

const BottomWidgetTempEntry = ({ id, type }) => {
  return (
    <ThemeProvider theme={LightTheme}>
      <ThemeWrapper color='primary'>
        <Suspense fallback={<></>}>
          <BottomWidget id={id} type={type} />
        </Suspense>
      </ThemeWrapper>
    </ThemeProvider>
  )
}

export default BottomWidgetTempEntry
